import { Pipe, PipeTransform } from '@angular/core';
import { FieldService } from '../../common/_services/field.service';
@Pipe({
  name: 'datafield',
  pure: true,
  standalone: false,
})
export class DatafieldPipe implements PipeTransform {
  constructor(private fieldService: FieldService) {}

  transform(value: any): any {
    if (!value || value === undefined) {
      return null;
    }

    const selected = this.fieldService.getFieldById(Number(value));
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
